import { render, staticRenderFns } from "./LinkNumAnalysis.vue?vue&type=template&id=2084f415&"
import script from "./LinkNumAnalysis.vue?vue&type=script&lang=js&"
export * from "./LinkNumAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports